import * as types from '../../actions/types';

const initialState = []

export default function curriculum (state = initialState, action) {
  switch (action.type) {
    
    case types.COMPLEX_TOPICS_DISCIPLINES_GET_CURRICULUM:
      return action.curriculum
    
    default:
      return state;
  }
}
